export default "__VITE_ASSET__4108a5d7__"